module.exports = __webpack_public_path__ + "img/edit.2f495e05.svg";